import React, { useState, useEffect, useRef } from 'react';
import api from '../api/api'; // Assurez-vous que le chemin est correct pour vos configurations

function ChatComponent({ matchRequestId, participantId, onMessageSent, onClose }) {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [error, setError] = useState(null);
    const modalRef = useRef(null);
	const [isTyping, setIsTyping] = useState(false);
	const bottomRef = useRef(null);
	const [otherTyping, setOtherTyping] = useState(false);
	const [inputFocused, setInputFocused] = useState(false);

    async function fetchMessages() {
        try {
            const response = await api.get(`/api/messages/${matchRequestId}`);
            if (response.data) {
                setMessages(response.data);
				setOtherTyping(false);
            } else {
                throw new Error('No data received');
            }
        } catch (error) {
            console.error("Failed to load messages:", error);
            setError("Failed to load messages");
            setMessages([]);
        }
    }

	useEffect(() => {
		fetchMessages();
		const interval = setInterval(fetchMessages, 3000); // Actualisation toutes les 3 secondes

		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				onClose();
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			clearInterval(interval); // Nettoyage à la fermeture
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [matchRequestId]);

	useEffect(() => {
		if (bottomRef.current && !inputFocused) {
			setTimeout(() => {
				bottomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
			}, 100);
		}
	}, [messages, inputFocused]);
		
	
	useEffect(() => {
		if (!messages.length) return;
		const otherId = messages.find(m => m.sender_id !== participantId)?.sender_id;
		if (!otherId) return;

		const interval = setInterval(async () => {
			try {
				const res = await api.get(`/api/typing-status?participant_id=${otherId}`);
				setOtherTyping(res.data.typing);
			} catch (e) {
				console.error("Erreur récupération statut de frappe :", e);
			}
		}, 3000);

		return () => clearInterval(interval);
	}, [messages, participantId]);

	const sendMessage = async () => {
		if (!newMessage.trim()) return;
		const messageData = {
			match_request_id: matchRequestId,
			sender_id: participantId,
			content: newMessage.trim()
		};

		try {
			const response = await fetch('/api/messages/send', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(messageData)
			});

			if (response.ok) {
				const responseData = await response.json();

				// 🔹 Récupère le destinataire
				const receiver_id = messages.find(m => m.sender_id !== participantId)?.sender_id;

				if (receiver_id) {
					await api.post('/api/messages/notify-email', {
						match_request_id: matchRequestId,
						sender_id: participantId,
						receiver_id,
						message: newMessage.trim(),
						lang: navigator.language.slice(0, 2) || "fr"
					});
				}

				onMessageSent(responseData);
				fetchMessages();
				setNewMessage('');
			} else {
				const errorData = await response.json();
				console.error("Failed to send message:", errorData.detail);
			}
		} catch (error) {
			console.error("Error sending message:", error);
		}
	};

    return (
        <div
			className="chat-container-Mobile"
			ref={modalRef}  // ✅ Ajoute ici
			style={{ width: '100%', height: '90vh' }}
		>
            <div
				className="messages-container-Mobile"
				style={{ overflowY: 'auto', maxHeight: '75%', display: 'flex', flexDirection: 'column' }}
				ref={modalRef}
			>
                {messages.map((msg, index) => (
                    <div key={index} className={`message ${participantId === msg.sender_id ? 'sent' : 'received'}`} style={{ padding: '10px', fontSize: '16px' }}>
                        {msg.content}
                    </div>
                ))}
				<div ref={bottomRef}></div>
            </div>
			{otherTyping && (
				<div className="text-xs text-gray-500 italic mb-2">
					✍️ Votre interlocuteur est en train d’écrire...
				</div>
			)}
			<div className="message-input-container-Mobile" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
				<input
					type="text"
					className="message-input-Mobile"
					value={newMessage}
					onChange={(e) => setNewMessage(e.target.value)}
					onKeyDown={() => {
						setIsTyping(true);
						api.post("/api/typing", { participant_id: participantId });
					}}
					onFocus={() => setInputFocused(true)}
					onBlur={() => {
						setIsTyping(false);
						setInputFocused(false);
					}}
					placeholder="Écrire un message..."
					style={{ flex: 1, height: '40px', marginRight: '10px', fontSize: '16px', padding: '0 10px' }}
					onKeyPress={(e) => {
						if (e.key === 'Enter' && !e.shiftKey) {
							e.preventDefault();
							sendMessage();
						}
					}}
				/>
				<button className="send-button-Mobile" onClick={sendMessage} style={{ width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<i className="fas fa-paper-plane"></i>
				</button>
			</div>
        </div>
    );
}

export default ChatComponent;
